import { type RezaOpravneni, useAuthStore } from '@gov-nx/store';

type RezaSelection =
	| {
			isActive: true;
			activeReza: RezaOpravneni;
			isRezaSelected: boolean;
	  }
	| {
			isActive: false;
			activeReza: null;
			isRezaSelected: false;
	  };
export const useRezaSelection = (): RezaSelection => {
	const activeReza = useAuthStore('activeReza');

	const isActive = activeReza !== null;
	const isMe = activeReza?.kod === '';

	return isActive
		? {
				isActive,
				isRezaSelected: isActive && !isMe,
				activeReza,
			}
		: {
				isActive,
				isRezaSelected: false,
				activeReza,
			};
};
